import React from 'react';

/**
 * FormCard Component
 * A styled card component for forms and content sections
 * 
 * @param {Object} props
 * @param {string} props.title - Card title
 * @param {string} props.subtitle - Optional subtitle
 * @param {React.ReactNode} props.icon - Optional icon component
 * @param {React.ReactNode} props.children - Card content
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.isDarkMode - Whether dark mode is enabled
 */
const FormCard = ({ title, subtitle, icon, children, className = '', isDarkMode }) => {
  return (
    <div className={`
      w-full rounded-lg overflow-hidden border transition-all duration-200
      ${isDarkMode 
        ? 'bg-gray-800 border-gray-700 shadow-md' 
        : 'bg-base-100 shadow-lg border-gray-200'
      } 
      ${className}
    `}>
      {(title || subtitle) && (
        <div className={`
          p-4 border-b
          ${isDarkMode ? 'border-gray-700 bg-gray-800/80' : 'border-gray-200 bg-base-100'}
        `}>
          <div className="flex items-center">
            {icon && <div className="mr-3">{icon}</div>}
            <div>
              {title && <h3 className={`font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>{title}</h3>}
              {subtitle && <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>{subtitle}</p>}
            </div>
          </div>
        </div>
      )}
      <div className="p-4">
        {children}
      </div>
    </div>
  );
};

export default FormCard; 